import { PanelShell, Badge, ApiResourceView, DJSEMApiClient, useApiResource, jobActionsFor } from "../index";

interface JobItem { id: string; label: string; status: "queued" | "running" | "succeeded" | "failed" | "cancelled"; }

/**
 * Jobs module — lists background jobs (analysis, render, import) with their status and the
 * actions available for each (e.g. retry, cancel).
 *
 * @param client - The API client used to fetch the jobs list.
 * @returns A panel of jobs with status badges and available actions (or the loading/error/empty view).
 */
export function JobsModule({ client }: { client: DJSEMApiClient }) {
  const res = useApiResource(() => client.listJobs(), [], (d) => (d.items?.length ?? 0) === 0);
  return (
    <ApiResourceView
      resource={res}
      empty={{ title: "No jobs running", detail: "Analysis, render and import jobs appear here with progress and retry actions." }}
      render={(data) => {
        const jobs = (data.items ?? []) as unknown as JobItem[];
        return (
          <PanelShell title="Jobs">
            {jobs.map((j) => (
              <div key={j.id} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0" }}>
                <span>{j.label} <Badge tone={j.status === "failed" ? "warn" : "ok"}>{j.status}</Badge></span>
                <span style={{ fontSize: 11 }}>{jobActionsFor(j).join(" · ")}</span>
              </div>
            ))}
          </PanelShell>
        );
      }}
    />
  );
}
